import React from 'react';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';
import Types from './Types';

export default function TypeOfChanges({
  setStepNumber,
  changedRequestInfo,
  setOptionNumber,
  open,
  endRequest = null,
}) {
  const hasNotChangeLine =
    !changedRequestInfo.LineDateChanged &&
    !changedRequestInfo.LineDetailsChanged;

  const header = 'What would you like to change?';

  const content = hasNotChangeLine
    ? "Select the first change you'd like to make.\n You'll be able to select more changes later."
    : 'Before you submit this request... ' +
      '\n' +
      'Do you need to change anything else?';

  return (
    <Dialog
      open={open}
      header={header}
      description={content}
      children={null}
      actions={
        <Types
          changedRequestInfo={changedRequestInfo}
          setStepNumber={setStepNumber}
          setOptionNumber={setOptionNumber}
        />
      }
      onClose={endRequest}
    />
  );
}
